const CloverConfig = require('@/lib/PaymentMethods/Clover/CloverConfig');
const CloverDriver = require('@/lib/PaymentMethods/Clover/CloverDriver');
const PaymentMethodRef = require('@/lib/PaymentMethods/PaymentMethodRef');
const { container } = require('@/container');
const { removeEmptyValues } = require('@/functions/objects');

app.factory(
    'cloverConfig',
    /**
     * @param hydrator
     * @param {CurrentDevice} currentDevice
     * @param {PaymentMethodService} paymentMethodService
     */
    function (
        hydrator,
        currentDevice,
        paymentMethodService
    ) {
        let config = new CloverConfig();
        let device = currentDevice.device;

        let paymentMethod = paymentMethodService.getByRef(PaymentMethodRef.CARD_CLOVER_CHIP_AND_PIN);
        if (!paymentMethod) {
            throw new Error('Company does not have Clover payment method enabled.');
        }

        // Set config from the company's payment method config.
        if (paymentMethod.config) {
            let companyTerminalConfig = null;
            let rawCompanyCloverConfig = JSON.parse(paymentMethod.config);
            // Clean the company config in case empty keys have been set in Backoffice.
            removeEmptyValues(rawCompanyCloverConfig);

            try {
                if (rawCompanyCloverConfig.merchants) {
                    companyTerminalConfig = rawCompanyCloverConfig.merchants.find(
                        (m) => m.branchIDs.find((branchID) => parseInt(branchID, 10) === container.userService.getOrderBranchID())
                    );
                }
            } catch (e) {}

            // We need to make the consumers of the config aware if the correct config was available.
            // For Clover, we need config per branch.
            config.configAvailableForCurrentBranch = !!companyTerminalConfig;

            hydrator.hydrate(companyTerminalConfig, config);
        }

        // Set config from the device's payment method config.
        if (device.paymentTerminalConfig) {
            if (device.paymentTerminalConfig.hasOwnProperty(PaymentMethodRef.CARD_CLOVER_CHIP_AND_PIN)) {
                hydrator.hydrate(device.paymentTerminalConfig[PaymentMethodRef.CARD_CLOVER_CHIP_AND_PIN], config);
            }
        }

        // An identifier for our device sent to Cover so let's just use device.ID.
        config.xPosId = String(device.ID);

        console.log('[CloverConfig]', config);

        return config;
    }
);

app.service('cloverDriver', CloverDriver);
